<template>
    <div class="send-message-bar">
        <template v-if="!errorSendingMessage">
            <div class="send-message-bar__add" v-bind:class="{'send-message-bar__add--cta' : !chat.conversationWindowOpen}">
                <div v-if="selectedFiles.length > 0"
                     class="send-message-bar__selected-files"> 
                    <div class="send-message-bar__selected-files__file" :class="{'send-message-bar__selected-files__file--first': selectedFiles.length > 1}"><img :src="selectedFiles[0].url" /></div>
                    <div v-if="selectedFiles.length > 1" class="send-message-bar__selected-files__file send-message-bar__selected-files__file--second"><img :src="selectedFiles[1].url" /></div>
                    <div class="send-message-bar__selected-files__file--remove" @click="removeFiles">X</div>
                </div>
                <button v-else
                        v-show="!sendingMessage"
                        v-on:click.stop="showAddContentDialog"
                        class="btn"><i class="fas fa-plus"></i></button>
            </div>

            <textarea v-if="chat.conversationWindowOpen" 
                      v-model="newMessage" 
                      rows="1"
                      ref="newMessage"></textarea>

            <div v-else class="send-message-bar__no-conv">
                <i class="fas fa-arrow-left"></i>
                <span class="d-inline d-lg-none">Start conversation, use template</span>
                <span class="d-none d-lg-inline">No open conversation - use a WhatsApp approved Template to start one.</span>
            </div>

            <div class="send-message-bar__action">
                <Spinner class="send-message-bar__spinner" v-show="sendingMessage"/>
                <button v-show="!sendingMessage"
                        v-on:click.prevent="sendMessage"
                        v-bind:class="{'btn-disabled' : !newMessage}"
                        v-bind:disabled="!newMessage && selectedFiles.length === 0"
                        class="btn btn-primary"><i class="fas fa-paper-plane fa-rotate-by"></i></button>
            </div>
        </template>
        <template v-else>
            <div class="alert alert-danger w-100" role="alert">
            {{errorSendingMessage}}
            <button v-on:click="clearSendingMessageError()" class="close" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            </div>
        </template>

        <AddContentDialog v-bind:selectedChat="chat" v-if="showingAddContentDialog"></AddContentDialog>
        <AddUsingTemplateDialog v-bind:selectedChat="chat" v-if="showingUsingTemplateDialog"></AddUsingTemplateDialog>
        <FileSelectorDialog v-bind:files="getFiles" v-if="showingFileSelectorDialog"/>
    </div>
</template>

<script>
    import { store, getters } from '../../store.js'

    import Spinner from '../Spinner.vue'
    import FileSelectorDialog from '../establishments/FileSelectorDialog.vue'

    import AddContentDialog from './AddContentDialog.vue'
    import AddUsingTemplateDialog from './AddUsingTemplateDialog.vue'

    const lineHeight = 24; // in px, should match the line-height in CSS

    export default {
        name: 'SendMessageBar',
        components: { Spinner, AddContentDialog, AddUsingTemplateDialog, FileSelectorDialog },
        props: {
            chat: {
                type: Object,
                required: true
            },
            chatWindowHeight: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                newMessage: "",
                showingAddContentDialog: false,
                showingUsingTemplateDialog: false,
                showingFileSelectorDialog: false,
                selectedFiles: [],
                sendingMessage: false,
                errorSendingMessage: null,
            };
        },
        computed: {
            getMaxRows: function() {
                const maxHeight = this.chatWindowHeight * 0.25;
                const maxRows = Math.floor(maxHeight / lineHeight);
                return maxRows;
            },
            getFiles: function() {
                return getters.getCurrentEstablishment().preferences.files;
            }
        },
        methods: {
            resizeTextarea: function(textarea) {
                // Reset height so scrollHeight measures correctly
                textarea.style.height = "auto";
                
                // Calculate the number of rows based on scrollHeight
                const rows = Math.floor(textarea.scrollHeight / lineHeight);

                if (rows <= this.getMaxRows) {
                    textarea.style.overflowY = "hidden";
                    textarea.style.height = textarea.scrollHeight + "px";
                } else {
                    textarea.style.overflowY = "auto";
                    textarea.style.height = lineHeight * this.getMaxRows + "px";
                }
            },
            showAddContentDialog: function() {
                // if (this.chat.conversationWindowOpen) {
                    // this.showingAddContentDialog = true;
                // } else {
                    this.showingUsingTemplateDialog = true;
                // }
            },
            hideAddContentDialog: function(type) {
                this.showingAddContentDialog = false;
                switch (type) {
                    case 'template':
                        this.showingUsingTemplateDialog = true;
                        break;
                    case 'media':
                        this.showingFileSelectorDialog = true;
                        break;
                }
            },
            hideUseTemplateDialog: function() {
                this.showingUsingTemplateDialog = false;
            },
            hideUseTemplateDialogAndSendFreeFormMessage: function(message) {
                this.showingUsingTemplateDialog = false;
                this.newMessage = message;
                this.sendMessage();
            },
            hideUseTemplateDialogAndSendTemplateMessage: function(templateReference, bookingReference) {
                this.showingUsingTemplateDialog = false;
                this.sendTemplateMessage(templateReference, bookingReference);
            },
            attachFiles: function(selectedFiles) {
                this.showingFileSelectorDialog = false;
                this.selectedFiles = selectedFiles;
            },
            removeFiles: function() {
                this.selectedFiles = [];
            },
            sendMessage: function() {
                console.log("Sending message");

                this.sendingMessage = true;

                if (this.selectedFiles.length > 0) {
                    this.sendMediaMessage();
                } else {
                    this.sendTextMessage();
                }
            },
            sendTextMessage: function() {
                console.log("Sending text message: " + this.newMessage);

                this.sendingMessage = true;

                const body = {
                    content: this.newMessage
                };

                this.$http.post('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/chats/' + this.chat.reference + '/send', body, {'axios-retry': {retries: 0}}
                ).then(response => {
                    this.$root.$emit("chat-message-sent", response.data);
                    this.newMessage = "";
                    this.$nextTick(() => {
                        this.resizeTextarea(this.$refs.newMessage);
                        this.$refs.newMessage.focus();
                    });
                }).catch(error => {
                    if (error.response && error.response.data.message) {
                        this.errorSendingMessage = error.response.data.message;
                    } else {
                        this.errorSendingMessage = "There was a problem sending your message. Please try again.";
                    }
                }).finally(() => {
                    this.sendingMessage = false;
                });
            },
            sendMediaMessage: function() {
                console.log("Sending media message. Files: " + this.selectedFiles.map(file => file.filename).join(", ") + ": " + this.newMessage);

                const formData = new FormData()
                formData.append('content', this.newMessage)
                for (const file of this.selectedFiles) {
                    formData.append('fileReferences', file.reference)
                }

                this.$http.post('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/chats/' + this.chat.reference + '/send-media', formData, {'axios-retry': {retries: 0}}
                ).then(response => {
                    this.$root.$emit("chat-message-sent", response.data);
                    this.newMessage = "";
                    this.removeFiles();
                    this.$nextTick(() => {
                        this.resizeTextarea(this.$refs.newMessage);
                        this.$refs.newMessage.focus();
                    });
                }).catch(error => {
                    if (error.response && error.response.data.message) {
                        this.errorSendingMessage = error.response.data.message;
                    } else {
                        this.errorSendingMessage = "There was a problem sending your media message. Please try again.";
                    }
                }).finally(() => {
                    this.sendingMessage = false;
                });
            },
            sendTemplateMessage: function(templateReference, bookingReference) {
                console.log("Sending template (" + templateReference + ") message: " + this.newMessage);

                this.sendingMessage = true;

                const body = {
                    templateReference: templateReference,
                    bookingReference: bookingReference
                };

                this.$http.post('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/chats/' + this.chat.reference + '/send-template', body, {'axios-retry': {retries: 0}}
                ).then(response => {
                    console.log("Template message sent successfully");
                    this.$root.$emit("chat-message-sent", response.data);
                    this.newMessage = "";
                    if (this.$refs.newMessage) {
                        console.log("Focusing new message input");
                        this.$nextTick(() => {
                            this.resizeTextarea(this.$refs.newMessage);
                            this.$refs.newMessage.focus();
                        });
                    }
                }).catch(error => {
                    if (error.response && error.response.data.message) {
                        this.errorSendingMessage = error.response.data.message;
                    } else {
                        this.errorSendingMessage = "There was a problem sending your template message. Please try again.";
                    }
                }).finally(() => {
                    this.sendingMessage = false;
                });
            },
            clearSendingMessageError: function() {
                this.errorSendingMessage = null;
            },
        },
        watch: {
            chat: function(newChat) {
                if (newChat && newChat.conversationWindowOpen) {
                    this.$nextTick(() => {
                        this.$refs.newMessage.addEventListener('input', (e) => {
                            this.resizeTextarea(e.target);
                        });            
                    });
                }
            }
        },
        mounted() {
            if (this.chat.conversationWindowOpen) {
                this.$refs.newMessage.addEventListener('input', (e) => {
                    this.resizeTextarea(e.target);
                });            
            }

            this.$root.$on('finished-chat-choosing-content-type', this.hideAddContentDialog);
            this.$root.$on('close-using-template-dialog', this.hideUseTemplateDialog);
            this.$root.$on('send-free-form-message', this.hideUseTemplateDialogAndSendFreeFormMessage);
            this.$root.$on('send-template-message', this.hideUseTemplateDialogAndSendTemplateMessage);
            this.$root.$on('finished-selecting-files', this.attachFiles);
        },
        beforeDestroy() {
            this.$root.$off('finished-chat-choosing-content-type', this.hideAddContentDialog);
            this.$root.$off('close-using-template-dialog', this.hideUseTemplateDialog);
            this.$root.$off('send-free-form-message', this.hideUseTemplateDialogAndSendFreeFormMessage);
            this.$root.$off('send-template-message', this.hideUseTemplateDialogAndSendTemplateMessage);
            this.$root.$off('finished-selecting-files', this.attachFiles);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/components/_send_message_bar.scss";
</style>